import { LocalizedString, localizedStringFromMap } from './LocalizedString';
import { JourneyStep, journeyStepFromJson } from './JourneyStep';

export type JourneyDifficulty = 'beginner' | 'intermediate' | 'advanced';
export type JourneyCategory = 'stress' | 'energy' | 'sleep' | 'focus' | 'general' | 'custom';

export interface Journey {
  id: string;
  position: number;
  isEnabled: boolean;
  name: LocalizedString;
  description: LocalizedString;
  goal: LocalizedString;
  difficulty: JourneyDifficulty;
  category: JourneyCategory;
  totalSteps: number;
  steps: JourneyStep[];
  activitiesIds: string[];
  benefitsIds: string[];
  isAiGenerated?: boolean;
  sourceJourneyId?: string | null;
  createdAt?: string | null;
}

export function journeyFromJson(json: Record<string, unknown>): Journey {
  return {
    id: json['id'] as string,
    position: json['position'] as number,
    isEnabled: (json['isEnabled'] as boolean | undefined) ?? true,
    name: localizedStringFromMap(json['name'] as Record<string, unknown>),
    description: localizedStringFromMap(json['description'] as Record<string, unknown>),
    goal: localizedStringFromMap(json['goal'] as Record<string, unknown>),
    difficulty: json['difficulty'] as JourneyDifficulty,
    category: json['category'] as JourneyCategory,
    totalSteps: json['totalSteps'] as number,
    steps: json['steps'] != null
      ? (json['steps'] as Record<string, unknown>[]).map(journeyStepFromJson)
      : [],
    activitiesIds: (json['activities'] as string[] | undefined) ?? [],
    benefitsIds: (json['benefits'] as string[] | undefined) ?? [],
    isAiGenerated: (json['isAiGenerated'] as boolean | undefined) ?? false,
    sourceJourneyId: (json['sourceJourneyId'] as string | null | undefined) ?? null,
    createdAt: (json['createdAt'] as string | null | undefined) ?? null,
  };
}
